export default {
    opacity: Boolean, 
    buttons: Boolean, 
    value: String, 
    preview: Boolean, 
    autoupdate: Boolean, 
    messages: Object, 

    // Events
    change: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoFlatColorPicker/FlatColorPickerProps.js